type PetcareRewardsIconProps = {
  classNames: {
    icon: string;
    petcare: string;
    rewards: string;
  };
};

const PetcareRewardsIcon = (props: PetcareRewardsIconProps) => {
  const { classNames } = props;

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 370 140"
      xmlSpace="preserve"
      className={classNames.icon}
    >
      <g>
        <path
          className={classNames.petcare}
          d="M113.63,33.56h16.31c1.55,0,2.81-1.26,2.81-2.81c0-1.55-1.26-2.81-2.81-2.81h-13.5v-5.93h9.65
  c1.55,0,2.81-1.26,2.81-2.81c0-1.55-1.26-2.81-2.81-2.81h-9.65v-5.93h13.33c1.55,0,2.81-1.26,2.81-2.81c0-1.55-1.26-2.81-2.81-2.81
  h-16.14c-1.55,0-2.81,1.26-2.81,2.81v23.11C110.82,32.3,112.08,33.56,113.63,33.56z"
        />
        <path
          className={classNames.petcare}
          d="M262.66,33.56h16.31c1.55,0,2.81-1.26,2.81-2.81c0-1.55-1.26-2.81-2.81-2.81h-13.5v-5.93h9.65
  c1.55,0,2.81-1.26,2.81-2.81c0-1.55-1.26-2.81-2.81-2.81h-9.65v-5.93h13.33c1.55,0,2.81-1.26,2.81-2.81c0-1.55-1.26-2.81-2.81-2.81
  h-16.14c-1.55,0-2.81,1.26-2.81,2.81v23.11C259.85,32.3,261.11,33.56,262.66,33.56z"
        />
        <path
          className={classNames.petcare}
          d="M179.22,33.96c4.21,0,8.02-1.66,11.01-4.8c1.07-1.12,1.03-2.9-0.1-3.98c-1.12-1.07-2.9-1.03-3.98,0.1
  c-1.96,2.06-4.23,3.06-6.94,3.06c-4.83,0-8.48-3.9-8.48-9.14c0-5.21,3.67-9.14,8.54-9.14c3.22,0,4.83,0.97,6.84,2.89
  c1.12,1.07,2.9,1.03,3.98-0.09c1.07-1.12,1.03-2.9-0.09-3.98c-2.42-2.31-5.39-4.44-10.72-4.44c-7.94,0-14.17,6.48-14.17,14.83
  C165.11,27.51,171.31,33.96,179.22,33.96z"
        />
        <path
          className={classNames.petcare}
          d="M85.58,33.57c1.55,0,2.81-1.26,2.81-2.81V24.2h5.52c6.74,0,11.1-3.79,11.1-9.67v-0.07
  c0-5.85-4.33-9.63-11.03-9.63h-8.4c-1.55,0-2.81,1.26-2.81,2.81v23.11C82.77,32.31,84.03,33.57,85.58,33.57z M88.4,10.46h5.58
  c3.59,0,5.41,1.35,5.41,4.01v0.07c0,1,0,4.04-5.47,4.04H88.4V10.46z"
        />
        <path
          className={classNames.petcare}
          d="M247.08,32.46c0.55,0.73,1.39,1.11,2.24,1.11c0.59,0,1.19-0.19,1.7-0.57c1.24-0.94,1.47-2.7,0.53-3.94
  l-5.2-6.83c4.42-1.6,6.15-4.99,6.15-8.27c0-4.41-3.19-9.12-12.15-9.12h-8.33c-1.55,0-2.81,1.26-2.81,2.81v23.11
  c0,1.55,1.26,2.81,2.81,2.81c1.55,0,2.81-1.26,2.81-2.81v-7.59H240L247.08,32.46z M234.82,10.46h5.52c1.96,0,6.53,0.34,6.53,3.56
  c0,2.63-3.05,3.34-5.47,3.49c-0.13,0-0.25,0-0.38,0.02c-0.26,0.01-0.52,0.02-0.76,0.02h-5.44V10.46z"
        />
        <path
          className={classNames.petcare}
          d="M141.37,10.46h5.9v20.3c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81v-20.3h5.9c1.55,0,2.81-1.26,2.81-2.81
  c0-1.55-1.26-2.81-2.81-2.81h-17.43c-1.55,0-2.81,1.26-2.81,2.81C138.56,9.2,139.82,10.46,141.37,10.46z"
        />
        <path
          className={classNames.petcare}
          d="M197.64,33.29c0.39,0.19,0.81,0.28,1.22,0.28c1.05,0,2.05-0.59,2.53-1.59l2.64-5.48h12.13l2.65,5.48
  c0.68,1.4,2.36,1.98,3.76,1.31c1.4-0.68,1.98-2.36,1.31-3.76l-3.36-6.94c0,0,0-0.01-0.01-0.01l-7.9-16.32
  c-0.47-0.97-1.45-1.59-2.53-1.59c0,0,0,0,0,0c-1.08,0-2.06,0.62-2.53,1.59l-7.62,15.8c-0.17,0.24-0.29,0.51-0.38,0.79l-3.22,6.68
  C195.65,30.93,196.24,32.61,197.64,33.29z M210.09,13.94l3.35,6.93h-6.69L210.09,13.94z"
        />
        <path
          className={classNames.rewards}
          d="M109.84,115.59c-13.41,9.69-26.5,11.05-38.92,4.03c-3.71-2.09-7.15-4.93-10.23-8.44
  c-0.02-0.03-0.05-0.05-0.07-0.08L41.72,90.4c12.02-3.07,16.54-12.27,16.54-20.98v-0.18c0-13.66-9.56-22.14-24.95-22.14H10.09
  c-3.2,0-5.8,2.6-5.8,5.8v54.13c0,3.2,2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8V91.47h11.1l25.02,27.42c3.94,4.47,8.38,8.11,13.2,10.84
  c6.91,3.9,14.18,5.84,21.55,5.84c9.97,0,20.14-3.54,29.87-10.57c2.6-1.88,3.18-5.5,1.3-8.1
  C116.06,114.3,112.43,113.71,109.84,115.59z M15.89,58.69h17.42c13.35,0,13.35,7.94,13.35,10.54v0.18
  c0,6.93-4.75,10.45-14.12,10.45H15.89V58.69z"
        />
        <path
          className={classNames.rewards}
          d="M176.69,60.38c-2.93-1.01-6.14,0.54-7.15,3.48l-8.88,25.69l-8.69-25.66c-0.77-2.28-2.92-3.82-5.33-3.82
  c-2.41,0-4.55,1.54-5.33,3.82l-8.64,25.51l-8.65-25.51c-1-2.94-4.19-4.52-7.13-3.52c-2.94,1-4.52,4.19-3.52,7.13l13.98,41.23
  c0.77,2.28,2.92,3.82,5.33,3.82c0,0,0,0,0,0c2.41,0,4.55-1.54,5.33-3.82l8.63-25.5l8.63,25.5c0.77,2.28,2.9,3.81,5.31,3.82
  c0.01,0,0.01,0,0.02,0c2.4,0,4.53-1.52,5.32-3.79l14.25-41.23C181.18,64.6,179.63,61.4,176.69,60.38z"
        />
        <path
          className={classNames.rewards}
          d="M228.37,91.47v-5.2c0.01-0.2,0.01-0.39,0-0.59v-4.04c0-6.39-1.89-11.69-5.46-15.34
  c-3.97-4.05-9.55-6.11-16.6-6.11c-5.49,0-10.66,1.31-16.28,4.13c-2.78,1.39-3.9,4.77-2.51,7.55c1.39,2.78,4.77,3.9,7.55,2.51
  c4.05-2.03,7.52-2.94,11.24-2.94c3.91,0,6.79,0.92,8.56,2.73c0.95,0.97,1.61,2.44,1.96,4.28c-3.22-0.62-6.59-0.93-10.24-0.93
  c-14.02,0-23.08,6.99-23.08,17.81v0.18c0,10.12,8.21,17.19,19.97,17.19c5.59,0,10.36-1.38,14.2-3.63c0.91,1.89,2.83,3.19,5.06,3.19
  c3.11,0,5.62-2.52,5.62-5.62V91.95c0-0.11,0.01-0.23,0.01-0.34C228.38,91.56,228.37,91.51,228.37,91.47z M203.48,101.44
  c-2.05,0-8.72-0.43-8.72-5.94v-0.18c0-6.24,9.86-6.56,11.83-6.56c3.92,0,7.29,0.4,10.53,1.27v1.72
  C217.02,96.44,211.83,101.44,203.48,101.44z"
        />
        <path
          className={classNames.rewards}
          d="M262.08,59.13c-5.31,0-10.82,3.13-14.84,8.09v-2.29c0-3.14-2.46-5.61-5.61-5.61c-3.04,0-5.51,2.52-5.51,5.61
  v42.3c0,3.14,2.46,5.61,5.61,5.61c3.09,0,5.51-2.46,5.51-5.61V90.65c0-11.56,5.77-19.16,15.5-20.32c2.9-0.44,4.85-2.68,4.85-5.59
  C267.59,61.54,265.22,59.13,262.08,59.13z"
        />
        <path
          className={classNames.rewards}
          d="M311.22,28.29c-3.11,0-5.62,2.52-5.62,5.62v30.43c-3.98-2.7-8.77-4.26-13.98-4.26
  c-14.28,0-25.04,11.17-25.04,25.97v0.17c0,14.9,10.77,26.14,25.04,26.14c5.28,0,10.14-1.6,14.15-4.36c0.6,2.46,2.81,4.29,5.46,4.29
  c3.11,0,5.62-2.52,5.62-5.62V33.92C316.85,30.81,314.33,28.29,311.22,28.29z M305.58,86.32c0,8.44-6,14.81-13.96,14.81
  c-9.06,0-13.79-7.49-13.79-14.9v-0.17c0-8.67,5.67-14.73,13.79-14.73c8.74,0,13.96,7.53,13.96,14.81V86.32z"
        />
        <path
          className={classNames.rewards}
          d="M346.86,79.21c-5.89-1.62-8.87-2.96-8.87-3.98v-0.16c0-1.24,2.42-3.04,6.81-3.04c3.3,0,7.03,1.26,9.98,3.37
  c2.53,1.8,6.04,1.22,7.84-1.31c1.81-2.53,1.22-6.04-1.31-7.85c-4.86-3.47-10.88-5.46-16.52-5.46c-10.46,0-18.05,6.01-18.05,14.29
  v0.16c0,10.1,10.72,13.06,17.15,14.83c8.99,2.45,10.58,3.92,10.58,6.1v0.16c0,2.95-3.95,5.17-9.18,5.17
  c-4.48,0-9.42-1.81-12.9-4.73c-2.38-2-5.93-1.69-7.92,0.69c-2,2.38-1.69,5.93,0.69,7.92c5.5,4.61,13.02,7.37,20.13,7.37
  c11.84,0,20.43-6.9,20.43-16.42v-0.16C365.71,84.35,353.9,81.13,346.86,79.21z"
        />
        <path
          className={classNames.rewards}
          d="M87.27,112.3c6.73,0,13.07-2.73,17.85-7.7c2.15-2.24,2.09-5.8-0.15-7.95c-2.24-2.15-5.8-2.09-7.95,0.15
  c-2.64,2.74-6.1,4.25-9.75,4.25c-6.37,0-11.25-3.68-13.13-9.43h30.35c1.51,0,2.95-0.61,4.01-1.68c1.06-1.08,1.64-2.53,1.61-4.04
  c-0.21-12.87-8.4-25.9-23.63-25.9c-13.92,0-24.42,11.17-24.42,25.99v0.16C62.07,101.31,72.67,112.3,87.27,112.3z M86.49,71.26
  c6.67,0,10.01,4.52,11.46,9.12H74.2C76.05,74.87,80.66,71.26,86.49,71.26z"
        />
      </g>
    </svg>
  );
};

export default PetcareRewardsIcon;
